import { render } from "./SimpleImageEdit.vue?vue&type=template&id=010a01d9"
import script from "./SimpleImageEdit.vue?vue&type=script&lang=js"
export * from "./SimpleImageEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__